module.exports = __webpack_public_path__ + "static/media/Account-Delete.bb445d1f.jpg";